export default __webpack_public_path__ + "static/realWorldImg3-9ad9fbf410f79761edbc23c4ecbd5410.png";